import defaultAgentPhoto from "./agent_no_photo_210x210.png";

export { defaultAgentPhoto };
